<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<dl>
  @if (user.email) {
    <div class="flex items-center gap-2">
      <dt>
        <span class="sr-only">E-Mail:</span>
        <ods-icon name="mail" fill="text" size="small" />
      </dt>
      <dd data-test-class="email">{{ user.email }}</dd>
    </div>
  }
  <div class="flex items-center gap-2">
    <dt>
      <span class="sr-only">Benutzername:</span>
      <ods-icon name="person" fill="text" size="small" />
    </dt>
    <dd data-test-class="username">{{ user.username }}</dd>
  </div>
</dl>
